import { render, staticRenderFns } from "./ScrollArrow.vue?vue&type=template&id=ce6ad4d2&scoped=true&"
var script = {}
import style0 from "./ScrollArrow.vue?vue&type=style&index=0&id=ce6ad4d2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ce6ad4d2",
  null
  
)

export default component.exports